import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getAppVersions } from '../../../services/app/app-service';
import { RESOURCE_CHANGED_EVENT } from './use-copilot';

/** Only a successful, empty versions response identifies an unpublished app. */
export default function useUnpublishedApp(appId, enabled = true) {
    const { key } = useLocation();
    const [result, setResult] = useState(null);

    useEffect(() => {
        if (!appId || !enabled) return undefined;
        let cancelled = false;
        let request = 0;
        const refresh = async () => {
            const current = ++request;
            try {
                const response = await getAppVersions(appId);
                if (!cancelled && current === request) {
                    // The service returns [] on failure. Do not mistake it for no versions.
                    setResult({ appId, unpublished: Array.isArray(response?.versions) && response.versions.length === 0 });
                }
            } catch (_) {
                if (!cancelled && current === request) setResult(null);
            }
        };
        const onChanged = event => {
            if (!event.detail?.appId || event.detail.appId === appId) refresh();
        };
        refresh();
        window.addEventListener('focus', refresh);
        window.addEventListener(RESOURCE_CHANGED_EVENT, onChanged);
        return () => {
            cancelled = true;
            window.removeEventListener('focus', refresh);
            window.removeEventListener(RESOURCE_CHANGED_EVENT, onChanged);
        };
    }, [appId, enabled, key]);

    return Boolean(enabled && appId && result?.appId === appId && result.unpublished);
}
